module.exports = __webpack_public_path__ + "img/home-lazer.28e38586.svg";